export default {
  notification: {
    name: '消息通知',
    prop: {
      //信息
      abstract: '摘要',
      push_users_count: 'App 推送次数',
      read_users_count: '已读次数',
      received_users_count: '发送用户数',
      admin: '发送人',
      title: '标题',
      user: '用户',
      users: '发送用户',
      gift_giving_info: '赠送信息',
      read_status: '阅读状态',
      send_time: '发送时间',
      service_provider: '运营商',
      valid_end_time: '有效时间',
      push_received_count: '推送接收数',
      // 提醒
      received_user: '发送用户',
      // 通告
      message_content: '内容',
      summary: '统计'
    },
    // Enum的属性
    users_statuses: {
      read: '已读',
      unread: '未读'
    },
    // Boolean的属性
    // 占位提示
    titles: {
      base_info: '基本信息',
      notification_info: '消息内容'
    },
    //标签
    list_tabs: {
      message: '信息',
      reminder: '提醒',
      announce: '通告'
    },
    // 优惠券选择的弹窗
    coupon_dialog: {
      label: {
        service_provider_id: '运营商',
        coupon_definition: '优惠券',
        coupons_count: '数量'
      },
      tips: '单次领取/发放获取{0}张优惠券'
    },
    // 充电卡选择的弹窗
    charging_card_dialog: {
      label: {
        charging_card_definition: '充电卡',
        cards_count: '数量'
      },
      tips: '单次领取/发放获取{0}张充电卡'
    }
  }
}
